import {msg, str} from '@lit/localize';
import {html, LitElement} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import style from '../../../../scss/choosePlan.scss';
import {
	SUB_ACTIVE,
	SUB_NONE,
	SUB_PAST_DUE,
	SUB_PAUSED, SUB_SCHEDULED_TO_CANCEL,
	SUB_TRIALING
} from '../../services/subscription/subscriptionStatus';
import {
	selectCancelDaysLeft,
	selectCurrentSubscription,
	selectLanguage,
	selectSubscribedPlan,
	selectSubscriptionStatus,
	selectTrialDaysLeft
} from '../../selectors';
import store from '../../store';

@customElement('arc-subscription-status')
export class SubscriptionStatus extends connect(store)(LitElement) {
	static styles = [style];

	static properties = {
		subscribedPlan: {type: Object},
		subscription: {type: Object},
		status: {type: String},
		lang: {type: String},
	};

	constructor() {
		super();
		this.subscribedPlan = null;
		this.subscription = null;
		this.status = '';
		this.trialDaysLeft = 0;
		this.cancellationDaysLeft = 0;
		this.lang = 'en';
	}

	stateChanged(state) {
		this.subscribedPlan = selectSubscribedPlan(state);
		this.subscription = selectCurrentSubscription(state);
		this.status = selectSubscriptionStatus(state);
		this.lang = selectLanguage(state);
		this.trialDaysLeft = selectTrialDaysLeft(state);
		this.cancellationDaysLeft = selectCancelDaysLeft(state);
	}

	render() {
		const statuses = {
			[SUB_TRIALING]: msg('in a trialing state.'),
			[SUB_ACTIVE]: msg('in an active state.'),
			[SUB_PAUSED]: msg('in a paused state.'),
			[SUB_PAST_DUE]: msg('in a past due state.'),
			[SUB_SCHEDULED_TO_CANCEL]: msg('scheduled to cancel.'),
		};

		const messages = {
			[SUB_TRIALING]: msg(str`Your trial ends in ${this.trialDaysLeft} days.`),
			[SUB_PAUSED]: msg('Your subscription is paused. Please contact support if you wish to restart your subscription.'),
			[SUB_PAST_DUE]: msg('Payments are overdue for this account.'),
			[SUB_SCHEDULED_TO_CANCEL]: msg(str`Your subscription will end in ${this.cancellationDaysLeft} days.`),
		};

		return (
			this.subscribedPlan &&
			!this.subscribedPlan.free &&
			html` <div class="choosePlanManage">
				<p>${msg('Your subscription is ') + statuses[this.status]}</p>
				${messages[this.status] && html`
					<p>
						${messages[this.status]}
					</p>
				`}
			</div>`
		);
	}
}
